import React, { useState, ReactNode } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import pluralize from 'pluralize'

import { SvgSearch } from '@chilipiper/icons/lib/Search'
import { Flex } from '../box'
import { Icon } from '../icon'
import { Text } from '../text'
import { TextField } from '../text-field/TextField'
import { BorderProps } from '../theme/borders' // do not simplify the import!

interface Props {
  children?: ReactNode
  initialSearch?: string
  itemsCount: number
  onSearch: (value: string) => void
  placeholder?: string
  preSearchChildren?: ReactNode
  searchBorders?: BorderProps
}

export const TableHeader = ({
  onSearch,
  itemsCount,
  initialSearch,
  children = [],
  preSearchChildren,
  searchBorders,
  placeholder = 'Search',
}: Props) => {
  const [searchValue, setSearchValue] = useState(initialSearch)

  const debounceOnSearch = useDebouncedCallback(onSearch, 500)

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchValue(value)
    debounceOnSearch(value)
  }

  return (
    <Flex
      h={10}
      bg='neutral-light-8'
      borderTopLeftRadius={8}
      borderTopRightRadius={8}
      style={{
        borderRadius: '8px 8px 0 0',
        boxShadow: 'inset 0 0 0 0.0625rem rgba(139,168,193,0.16)',
      }}
    >
      <Flex
        alignItems='center'
        justifyContent='center'
        w={13}
        boxShadow='box-neutral-default-right-divider'
      >
        <Text color='neutral-dark-48'>
          {itemsCount} {pluralize('item', itemsCount)}
        </Text>
      </Flex>
      {preSearchChildren}
      <Flex alignItems='center' flex={1}>
        <TextField
          h='100%'
          borderRadius='none'
          boxShadow='none'
          onWhite={false}
          bg='none'
          placeholder={placeholder}
          startContent={<Icon color='neutral-dark-16' w={4} icon={SvgSearch} />}
          value={searchValue}
          onChange={onSearchInputChange}
          data-test-id='TableHeader-search'
          {...searchBorders}
        />
      </Flex>
      {children}
    </Flex>
  )
}
